import { render, staticRenderFns } from "./preimum-side.vue?vue&type=template&id=006d46d5&scoped=true&"
import script from "./preimum-side.vue?vue&type=script&lang=js&"
export * from "./preimum-side.vue?vue&type=script&lang=js&"
import style0 from "./preimum-side.vue?vue&type=style&index=0&id=006d46d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006d46d5",
  null
  
)

export default component.exports